"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferMessage = exports.CostBreakDownMargin = exports.PopoverEmpty = exports.PopoverContainer = exports.ContainerStyled = exports.DURATION = exports.FixedParent = exports.Title = exports.HeaderTitle = exports.Placeholder = exports.StyledHeader = exports.EmptyText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("./helpers");
const widget_1 = require("./widget");
exports.EmptyText = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.space.s100};

  color: ${({ theme }) => theme.colors.gray.s700};

  font-family: ${({ theme }) => theme.fontFamily.text};
  font-weight: 500;
`;
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
`;
exports.Placeholder = (0, styled_components_1.default)(widget_1.Placeholder) `
  position: static;

  height: 0;
`;
exports.HeaderTitle = styled_components_1.default.div `
  margin-bottom: 14px;

  color: ${({ theme }) => theme.colors.gray.s800};

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1rem;
  font-weight: 500;

  ${helpers_1.hideOnMobile};
`;
exports.Title = styled_components_1.default.div `
  font-size: 1.625rem;
  font-weight: 500;
`;
const WidgetPopoverBase = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  max-height: 100%;
`;
const MARGIN = 12;
exports.FixedParent = styled_components_1.default.div `
  position: absolute;
  top: ${({ openNew }) => (openNew ? '50px' : '-20px')};
  right: -20px;

  display: flex;
  flex-direction: column;

  width: 100vw;
  max-height: calc(100vh - 100%);

  @media ${helpers_1.onDesktop} {
    top: -${MARGIN}px;
    right: -${MARGIN}px;

    width: unset;
    min-width: 436px;
    max-width: calc(100vw - ${MARGIN}px);
    margin-bottom: 20px;
  }
`;
exports.DURATION = 200;
exports.ContainerStyled = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  box-sizing: border-box;
  width: 100%;
  max-height: 100%;

  background-color: ${({ theme }) => theme.colors.grayscale.lightest};

  font-family: ${({ theme }) => theme.variables.fontFamily.text};

  border-color: ${({ theme }) => theme.colors.grayscale.gray};
  border-radius: 0 0 ${({ theme }) => theme.radius.s200} ${({ theme }) => theme.radius.s200};
  box-shadow: ${({ theme }) => theme.shadow.z3};
  opacity: 0;

  transition-duration: ${exports.DURATION}ms;
  transition-property: opacity;
  transition-timing-function: ease-in-out;

  &.enter-active,
  &.enter-done {
    opacity: 1;
  }

  @media ${helpers_1.onDesktop} {
    border-radius: ${({ theme }) => theme.radius.s200};
  }
`;
exports.PopoverContainer = (0, styled_components_1.default)(WidgetPopoverBase) `
  padding: ${({ isNewItem, theme }) => (isNewItem ? theme.space.s200 : theme.space.s500)} ${({ theme }) => theme.space.s200}
    ${({ theme }) => theme.space.s200};

  @media ${helpers_1.onDesktop} {
    padding: ${({ theme }) => theme.space.s400} ${({ theme }) => theme.space.s300}
      ${({ isReopenOrder, theme }) => (isReopenOrder ? theme.space.s100 : theme.space.s300)} ${({ theme }) => theme.space.s300};
  }
`;
exports.PopoverEmpty = (0, styled_components_1.default)(WidgetPopoverBase) `
  box-sizing: border-box;
  padding: ${({ theme }) => theme.space.s900} ${({ theme }) => theme.space.s300};

  text-align: center;
`;
exports.CostBreakDownMargin = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.space.s300};
`;
exports.OfferMessage = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.space.s150};

  color: ${({ theme }) => theme.colors.gray.s800};

  font-size: 0.875rem;
  text-align: center;
`;
